import React from 'react';
import {
	DangerousGoodsModel,
} from 'models';




import {
	EntryListItem, EntryListModal,
} from '../ entryListModal/EntryListModal';
import {
	DangerousGoodsIcon,
} from '../../../dangerousGoods/DangerousGoodsIcon';
import './dangerousGoodsList.scss';

interface Props {
	/**
	 * The name of the current lot, if any
	 */
	goods: DangerousGoodsModel[],

	/*
	 * Function to be called when modal is closed without a selection being made
	 */
	onClose: () => void,
}
// @ts-ignore
export const DangerousGoodsList = ({
	goods,
	onClose,
}: Props) => {
	if (!goods || !goods.length) {
		return null;
	}
	return (
		<EntryListModal
			onClose={onClose}
			title="Farlig gods"
		>
			{goods.map((dangerousGoods) => {
				if (!dangerousGoods) {
					// Just to make it shut up about dangerousGoods potentially being undefined (we've filtered them away)
					return null;
				}

				return (
					<EntryListItem<DangerousGoodsModel>
						key={`dangerous-goods-list-${dangerousGoods?.hazardIdentificationNumber}`}
						description={(
							<div className="dangerous-goods-list-item">
								<div className="dangerous-goods-column">
									<DangerousGoodsIcon
										fontSize="24px"
										dangerousGoods={dangerousGoods}
									/>
									<div className="goods-name">
										{dangerousGoods.name || 'Navn mangler'}
									</div>
								</div>
							</div>)}
						data={dangerousGoods}
					/>
				);
			})}
		</EntryListModal>
	);
};